import React from 'react'
import Footer from '../component/Footer'
import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react'
import api from '../api'

const Contact = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [formData, setFormData] = useState({
        firstname: '', lastname: '', phone: '', email: '', message: ''
    });
    const [loading, setLoading] = useState(false);
    const [popup, setPopup] = useState({ show: false, success: false, message: '' });

    const handleChange = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = async () => {
        const { firstname, lastname, phone, email, message } = formData;

        if (!firstname || !lastname || !phone || !email || !message) {
            setPopup({ show: true, success: false, message: 'Please fill in all required fields.' });
            return;
        }

        setLoading(true);
        try {
            const res = await api.post(`/user/send-query`, {
                name: `${firstname} ${lastname}`,
                email,
                phone,
                message
            });

            // ✅ Axios: response data is directly in res.data — no .json() needed
            const data = res.data;

            console.log("Contact Submit >>", data);

            if (data.success) {
                setPopup({ show: true, success: true, message: 'Your query has been submitted successfully! We will get back to you soon.' });
                setFormData({ firstname: '', lastname: '', phone: '', email: '', message: '' });
            } else {
                setPopup({ show: true, success: false, message: data.message || 'Something went wrong. Please try again.' });
            }
        } catch (error) {
            console.log("Contact Error >>", error);
            setPopup({ show: true, success: false, message: error?.response?.data?.message || 'Network error. Please check your connection and try again.' });
        } finally {
            setLoading(false);
        }
    };

    const closePopup = () => setPopup({ show: false, success: false, message: '' });

    const handleScrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });

        const toggleVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    return (
        <>
            {/* Success/Error Popup */}
            {popup.show && (
                <div style={{
                    position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.55)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    zIndex: 9999
                }}>
                    <div style={{
                        background: '#fff', borderRadius: '12px', padding: '2.5rem 2rem',
                        maxWidth: '420px', width: '90%', textAlign: 'center',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.2)'
                    }}>
                        <div style={{
                            width: '68px', height: '68px', borderRadius: '50%',
                            margin: '0 auto 1.2rem',
                            backgroundColor: popup.success ? '#e9f7ef' : '#fdecea',
                            display: 'flex', alignItems: 'center', justifyContent: 'center'
                        }}>
                            {popup.success ? (
                                <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="12" fill="#27ae60" />
                                    <path d="M7 12.5l3.5 3.5 6.5-7" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            ) : (
                                <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
                                    <circle cx="12" cy="12" r="12" fill="#e74c3c" />
                                    <path d="M8 8l8 8M16 8l-8 8" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" />
                                </svg>
                            )}
                        </div>
                        <h3 style={{ marginBottom: '0.5rem', color: '#1a1a1a', fontSize: '1.25rem', fontWeight: '600' }}>
                            {popup.success ? 'Query Submitted!' : 'Oops!'}
                        </h3>
                        <p style={{ color: '#666', marginBottom: '1.8rem', lineHeight: '1.6', fontSize: '0.95rem' }}>
                            {popup.message}
                        </p>
                        <button
                            onClick={closePopup}
                            style={{
                                padding: '0.65rem 2.2rem', borderRadius: '6px', border: 'none',
                                cursor: 'pointer',
                                backgroundColor: popup.success ? '#27ae60' : '#e74c3c',
                                color: '#fff', fontSize: '1rem', fontWeight: '500'
                            }}
                        >
                            {popup.success ? 'Great, Thanks!' : 'Try Again'}
                        </button>
                    </div>
                </div>
            )}

            <main className="main__content_wrapper">

                {/* End breadcrumb section */}

                {/* Start contact section */}
                <section className="contact__section section--padding">
                    <div className="container">
                        <div className="section__heading text-center mb-40">
                            <h2 className="section__heading--maintitle">Get In Touch</h2>
                        </div>
                        <div className="main__contact--area position__relative">

                            <div className="contact__form">
                                <h3 className="contact__form--title mb-40">Contact Me</h3>
                                <div className="contact__form--inner">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6">
                                            <div className="contact__form--list mb-20">
                                                <label className="contact__form--label" htmlFor="input1">
                                                    First Name <span className="contact__form--label__star">*</span>
                                                </label>
                                                <input
                                                    className="contact__form--input"
                                                    name="firstname"
                                                    id="input1"
                                                    placeholder="Your First Name"
                                                    type="text"
                                                    value={formData.firstname}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="contact__form--list mb-20">
                                                <label className="contact__form--label" htmlFor="input2">
                                                    Last Name <span className="contact__form--label__star">*</span>
                                                </label>
                                                <input
                                                    className="contact__form--input"
                                                    name="lastname"
                                                    id="input2"
                                                    placeholder="Your Last Name"
                                                    type="text"
                                                    value={formData.lastname}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="contact__form--list mb-20">
                                                <label className="contact__form--label" htmlFor="input3">
                                                    Phone Number <span className="contact__form--label__star">*</span>
                                                </label>
                                                <input
                                                    className="contact__form--input"
                                                    name="phone"
                                                    id="input3"
                                                    placeholder="Phone number"
                                                    type="text"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="contact__form--list mb-20">
                                                <label className="contact__form--label" htmlFor="input4">
                                                    Email <span className="contact__form--label__star">*</span>
                                                </label>
                                                <input
                                                    className="contact__form--input"
                                                    name="email"
                                                    id="input4"
                                                    placeholder="Email"
                                                    type="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="contact__form--list mb-15">
                                                <label className="contact__form--label" htmlFor="input5">
                                                    Write Your Message <span className="contact__form--label__star">*</span>
                                                </label>
                                                <textarea
                                                    className="contact__form--textarea"
                                                    name="message"
                                                    id="input5"
                                                    placeholder="Write Your Message"
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <button
                                        className="contact__form--btn primary__btn"
                                        type="button"
                                        onClick={handleSubmit}
                                        disabled={loading}
                                        style={{ opacity: loading ? 0.7 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}
                                    >
                                        {loading ? 'Submitting...' : 'Submit Now'}
                                    </button>
                                </div>
                            </div>

                            <div className="contact__info border-radius-5">
                                <div className="contact__info--items">
                                    <h3 className="contact__info--content__title text-white mb-15">Contact Us</h3>
                                    <div className="contact__info--items__inner d-flex">
                                        <div className="contact__info--icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="31.568" height="31.128" viewBox="0 0 31.568 31.128">
                                                <path id="ic_phone_forwarded_24px" d="M26.676,16.564l7.892-7.782L26.676,1V5.669H20.362v6.226h6.314Zm3.157,7a18.162,18.162,0,0,1-5.635-.887,1.627,1.627,0,0,0-1.61.374l-3.472,3.424a23.585,23.585,0,0,1-10.4-10.257l3.472-3.44a1.48,1.48,0,0,0,.395-1.556,17.457,17.457,0,0,1-.9-5.556A1.572,1.572,0,0,0,10.1,4.113H4.578A1.572,1.572,0,0,0,3,5.669,26.645,26.645,0,0,0,29.832,32.128a1.572,1.572,0,0,0,1.578-1.556V25.124A1.572,1.572,0,0,0,29.832,23.568Z" transform="translate(-3 -1)" fill="currentColor" />
                                            </svg>
                                        </div>
                                        <div className="contact__info--content">
                                            <p className="contact__info--content__desc text-white">
                                                Change the design through a range <br />
                                                <a href="tel:+918433314555">+918433314555</a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="contact__info--items">
                                    <h3 className="contact__info--content__title text-white mb-15">Email Address</h3>
                                    <div className="contact__info--items__inner d-flex">
                                        <div className="contact__info--icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="31.57" height="31.13" viewBox="0 0 31.57 31.13">
                                                <path id="ic_email_24px" d="M30.413,4H5.157C3.421,4,2.016,5.751,2.016,7.891L2,31.239c0,2.14,1.421,3.891,3.157,3.891H30.413c1.736,0,3.157-1.751,3.157-3.891V7.891C33.57,5.751,32.149,4,30.413,4Zm0,7.783L17.785,21.511,5.157,11.783V7.891l12.628,9.728L30.413,7.891Z" transform="translate(-2 -4)" fill="currentColor" />
                                            </svg>
                                        </div>
                                        <div className="contact__info--content">
                                            <p className="contact__info--content__desc text-white">
                                                <a href="mailto:sales@overay.in">sales@overay.in</a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="contact__info--items">
                                    <h3 className="contact__info--content__title text-white mb-15">Office Location</h3>
                                    <div className="contact__info--items__inner d-flex">
                                        <div className="contact__info--icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="31.57" height="31.13" viewBox="0 0 31.57 31.13">
                                                <path id="ic_account_balance_24px" d="M5.323,14.341V24.718h4.985V14.341Zm9.969,0V24.718h4.985V14.341ZM2,32.13H33.57V27.683H2ZM25.262,14.341V24.718h4.985V14.341ZM17.785,1,2,8.412v2.965H33.57V8.412Z" transform="translate(-2 -1)" fill="currentColor" />
                                            </svg>
                                        </div>
                                        <div className="contact__info--content">
                                            <p className="contact__info--content__desc text-white">
                                                Gindan Khera, Nadarganj, Amausi, Lucknow, Uttar Pradesh 226008
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="contact__info--items">
                                    <h3 className="contact__info--content__title text-white mb-15">Follow Us</h3>
                                    <ul className="contact__info--social d-flex">
                                        <li className="contact__info--social__list">
                                            <a className="contact__info--social__icon" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="7.667" height="16.524" viewBox="0 0 7.667 16.524">
                                                    <path data-name="Path 237" d="M967.495,353.678h-2.3v8.253h-3.437v-8.253H960.13V350.77h1.624v-1.888a4.087,4.087,0,0,1,.264-1.492,2.9,2.9,0,0,1,1.039-1.379,3.626,3.626,0,0,1,2.153-.6l2.549.019v2.833h-1.851a.732.732,0,0,0-.472.151.8.8,0,0,0-.246.642v1.719H967.8Z" transform="translate(-960.13 -345.407)" fill="currentColor" />
                                                </svg>
                                                <span className="visually-hidden">Facebook</span>
                                            </a>
                                        </li>
                                        <li className="contact__info--social__list">
                                            <a className="contact__info--social__icon" target="_blank" rel="noopener noreferrer" href="https://twitter.com/">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16.489" height="13.384" viewBox="0 0 16.489 13.384">
                                                    <path data-name="Path 303" d="M966.025,1144.2v.433a9.783,9.783,0,0,1-.621,3.388......" transform="translate(-951.23 -1140.849)" fill="currentColor" />
                                                </svg>
                                                <span className="visually-hidden">Twitter</span>
                                            </a>
                                        </li>
                                        <li className="contact__info--social__list">
                                            <a className="contact__info--social__icon" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16.497" height="16.492" viewBox="0 0 19.497 19.492">
                                                    <path data-name="Icon awesome-instagram" d="M9.747,6.24a5,5,0,1,0,5,5A4.99,4.99,0,0,0,9.747,6.24Zm0,8.247A3.249,3.249,0,1,1,13,11.238a3.255,3.255,0,0,1-3.249,3.249Zm6.368-8.451A1.166,1.166,0,1,1,14.949,4.87,1.163,1.163,0,0,1,16.115,6.036Zm3.31,1.183A5.769,5.769,0,0,0,17.85,3.135,5.807,5.807,0,0,0,13.766,1.56c-1.609-.091-6.433-.091-8.042,0A5.8,5.8,0,0,0,1.64,3.13,5.788,5.788,0,0,0,.065,7.215c-.091,1.609-.091,6.433,0,8.042A5.769,5.769,0,0,0,1.64,19.341a5.814,5.814,0,0,0,4.084,1.575c1.609.091,6.433.091,8.042,0a5.769,5.769,0,0,0,4.084-1.575,5.807,5.807,0,0,0,1.575-4.084c.091-1.609.091-6.429,0-8.038Zm-2.079,9.765a3.289,3.289,0,0,1-1.853,1.853c-1.283.509-4.328.391-5.746.391S5.28,19.341,4,18.837a3.289,3.289,0,0,1-1.853-1.853c-.509-1.283-.391-4.328-.391-5.746s-.113-4.467.391-5.746A3.289,3.289,0,0,1,4,3.639c1.283-.509,4.328-.391,5.746-.391s4.467-.113,5.746.391a3.289,3.289,0,0,1,1.853,1.853c.509,1.283.391,4.328.391,5.746S17.855,15.705,17.346,16.984Z" transform="translate(0.004 -1.492)" fill="currentColor" />
                                                </svg>
                                                <span className="visually-hidden">Instagram</span>
                                            </a>
                                        </li>
                                        <li className="contact__info--social__list">
                                            <a className="contact__info--social__icon" target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16.49" height="11.582" viewBox="0 0 16.49 11.582">
                                                    <path data-name="Path 321" d="M967.759,1365.592q0,1.377-.019,1.717......" transform="translate(-951.269 -1359.8)" fill="currentColor" />
                                                </svg>
                                                <span className="visually-hidden">Youtube</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                {/* End contact section */}

                {/* Start contact map area */}
                <div className="contact__map--area section--padding pt-0">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7124.763962687035!2d80.86463153816801!3d26.764091236418885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bf93e8c15e881%3A0x27652a2f5be13c0e!2sGindan%20Khera%2C%20Amausi%2C%20Lucknow%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1750929816816!5m2!1sen!2sin"
                        width="100%"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Google Map"
                    />
                </div>
                {/* End contact map area */}

            </main>

            {/* Start footer section */}
            <Footer />
            {/* End footer section */}

            {/* Scroll top bar */}
            {isVisible && (
                <button id="scroll__top" onClick={handleScrollTop}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512">
                        <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M112 244l144-144 144 144M256 120v292" />
                    </svg>
                </button>
            )}
        </>
    );
};

export default Contact;